import { Component, ViewChild } from '@angular/core';
import { MdDialog } from '@angular/material';

import { ConstantsService } from 'app/services/constants-service';
import { GlobalValuesService } from 'app/services/global-values.service';
import { GenericSearchDetails } from 'app/shared/models/generic-search-details.model';

import { CookieService } from 'app/services/cookie.service';
import { MessageService } from 'app/services/messages.service';
import { CreateOrganisationComponent } from 'app/shared/components/createorganisation/create-organisation.component';
import { CreatePersonComponent } from 'app/shared/components/createperson/create-person.component';

import { HeaderService } from './header.service';
import { UserIdleService } from 'app/services/user-idle.service';
import {AuthenticationGuard} from '../services/authentication-guard.service';

@Component({
    selector: 'app-header',
    providers: [HeaderService],
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.css']
})

export class HeaderComponent {
    displayLoginName = 'Administrator';
    headerSearchURI = ConstantsService.HEADER_SEARCH;
    searchPlaceholder = MessageService.HEADER_SEARCH_PLACEHOLDER;

    constructor(public dialog: MdDialog,
        private userIddleService: UserIdleService,
        private globalValuesService: GlobalValuesService,
        private authenticationGuard: AuthenticationGuard,
        private cookieService: CookieService,
        private headerService: HeaderService) {
        const loginName = cookieService.get(ConstantsService.COOKIE_LOGIN_NAME);
        this.displayLoginName = this.headerService.limitDisplayName(loginName, ConstantsService.MENU_LOGIN_NAME_MAX_LENGTH);
    }

    openNewOrgDialog() {
        this.dialog.open(CreateOrganisationComponent);
    }

    openNewPersonDialog() {
        this.dialog.open(CreatePersonComponent);
    }

    onEntitySelection(searchDetails: GenericSearchDetails) {
    }
    notDnb() {
      return !this.authenticationGuard.isDnbUser();
    }
}



// WEBPACK FOOTER //
// ./src/app/header/header.component.ts